import {delegate} from './events';

export default function () {
    var fileFields = document.querySelectorAll('.form__field--type-file');
    if (!fileFields.length) {
        return;
    }

    Array.prototype.forEach.call(fileFields, function (field) {
        var label = field.querySelector('label');

        var filename = document.createElement('span');
        filename.classList.add('form__filename');
        filename.classList.add('form__filename--empty');
        filename.classList.add('print-off');

        filename.setAttribute('data-label', (function (node) {
            if (!node) {
                throw new Error('.form__field--type-file must have a parent with a [data-file-field-label] attribute.');
            }
            return node.getAttribute('data-file-field-label');
        })(field.closest('[data-file-field-label]')));
        filename.innerText = filename.getAttribute('data-label');

        label.insertAdjacentElement('beforeend', filename);
        field.querySelector('input[type="file"]')._filename = filename;
    });

    document.addEventListener('change', delegate('.form__field--type-file input[type="file"]', function () {
        var input = this;
        var info = /([^/\\]+)$/.exec(input.value);
        input._filename.innerText = info ? info[1] : input._filename.getAttribute('data-label');
        input._filename.classList.toggle('form__filename--empty', !info);
    }));
}